var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":_vm.internal_xs,"offset":_vm.offset(_vm.internal_xs),"sm":_vm.internal_sm,"offset-sm":_vm.offset(_vm.internal_sm),"md":_vm.internal_md,"offset-md":_vm.offset(_vm.internal_md),"lg":_vm.internal_lg,"offset-lg":_vm.offset(_vm.internal_lg),"xl":_vm.internal_xl,"offset-xl":_vm.offset(_vm.internal_xl)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }